import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import HttpService from '../services/HttpService';
import UserService from '../services/UserService';
import { basicUserDbInfo } from '../hooks/UserInfo';
import { decodeRedirectUrl } from '../lib/utils';

function AuthKeycloakLandPage() {
  const [searchParams] = useSearchParams();
  const redirectTo = searchParams.get('redirectUrl') || `${process.env.PUBLIC_URL}`; 
  
  const { basicUserInfo, loading } = basicUserDbInfo();
  const navigate = useNavigate();
  const registerUser = async () => {
    try {
      await HttpService.getAxiosClient().post(`${process.env.REACT_APP_BACKEND_URL}/users/keycloak`);

      if (UserService.hasRole(['EXTERNAL_TAXISNET'])) {
        if (!basicUserInfo.email) {
          navigate('/email-register');
        } else {
          return window.location.href = decodeRedirectUrl(redirectTo);
        }

      }

      window.location.href = decodeRedirectUrl(redirectTo);

    } catch (error) {
      navigate('/');
      console.error(error);
    }
  };
  useEffect(() => {
    !loading && registerUser();
  }, [loading]);

  return (<></>);
}
export default AuthKeycloakLandPage;